import { create } from 'zustand';

interface CrmUiState {
  /** Включена ли интеграция с CRM (источник истины — сервер). */
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

/**
 * Мгновенный UI-флаг включённости CRM.
 * Синхронизируется из ответа сервера (useCrmEnabled / useUpdateCrmSettings).
 * Читается карточками филиала, чтобы показать переключатель
 * «Отчёт / Сквозная аналитика».
 */
export const useCrmStore = create<CrmUiState>()((set) => ({
  enabled: false,
  setEnabled: (enabled) => set({ enabled }),
}));

export default useCrmStore;
